import { render, staticRenderFns } from "./AppealForm.vue?vue&type=template&id=f32fe85a&scoped=true&"
import script from "./AppealForm.vue?vue&type=script&lang=js&"
export * from "./AppealForm.vue?vue&type=script&lang=js&"
import style0 from "./AppealForm.vue?vue&type=style&index=0&id=f32fe85a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32fe85a",
  null
  
)

export default component.exports